import "../components/ContactFileUploader";
import "../components/ContactImageUploader";
import "../components/ContactImagesValidator";
import { PostalCodeAutoFill } from "../components/PostalCodeAutoFill";
import { FormFieldVisibilityController } from "../components/FormFieldVisibilityController";
import { FormBackButton } from "../components/FormBackButton";
import { IndustrySelectorModal } from "../components/IndustrySelectorModal";
import { FormSubmitPrevention } from "../components/FormSubmitPrevention";
import { cleanupQueryParamsFromLinks } from "../utils";
import { ContactHashRedirect } from "../components/ContactHashRedirect";
import { TelAccordion } from "../components/TelAccordion";

// 郵便番号自動入力機能を初期化
document.addEventListener('DOMContentLoaded', () => {
  // ハッシュフラグメントによるリダイレクト処理（最優先で実行）
  new ContactHashRedirect();

  new PostalCodeAutoFill();
  new FormFieldVisibilityController();
  new FormBackButton();
  new IndustrySelectorModal();
  new FormSubmitPrevention();
  new TelAccordion();

  // グローバルナビ、フッター、パンくずリスト、ボタンエリアのリンクからクエリパラメータを削除
  cleanupQueryParamsFromLinks(['#js-global-nav', '.f-footer', '.s-wrapper__tag', '.co-buttonArea']);
});